import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getBusinessInsights } from './api';
import { BusinessInsightsResponse } from './types';

export function useGetBusinessInsights(options?: UseQueryOptions<BusinessInsightsResponse, Error>) {
  return useQuery<BusinessInsightsResponse>({
    queryKey: ['business_insights'],
    queryFn: getBusinessInsights,
    ...options
  });
}
